// extracted by mini-css-extract-plugin
export default {"container":"DroppableBox_container__50IjV","box":"DroppableBox_box__tSiip"};